<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div>
    <el-dialog
      title="合同签署"
      :visible.sync="contractSignDialog"
      width="300px"
      @open="openDialog"
      :before-close="close"
    >
      <div style="padding: 0 30px">
        <div
          style="
            display: flex;
            justify-content: space-between;
            color: green;
            font-size: 14px;
          "
        >
          <div>
            <i
              class="el-icon-success"
              :style="{ color: fddInformation.member ? 'green' : 'red' }"
            ></i>

            <span
              :style="{
                margin: ' 0 10px',
                color: fddInformation.member ? 'green' : 'red',
              }"
              >企业会员已开通</span
            >
            <el-button type="text" @click="go3xPage">去续费</el-button>
          </div>
          <div>
            <i
              class="el-icon-success"
              :style="{ color: fddInformation.company ? 'green' : 'red' }"
            ></i>
            <span
              :style="{
                margin: ' 0 10px',
                color: fddInformation.company ? 'green' : 'red',
              }"
              >企业CA已认证</span
            >
            <el-button type="text" @click="go3xPage">签章管理</el-button>
          </div>
        </div>
        <div v-if="signList.length">
          <div class="title">选择签订人</div>
          <el-row>
            <el-col
              v-for="item in signList"
              :key="item.userId"
              :class="[
                activeSignId == item.userId ? 'active-d sign-d' : 'sign-d',
              ]"
            >
              <div
                style="
                  display: flex;
                  justify-content: space-between;
                  align-items: center;
                  width: 100%;
                "
                @click="setActiveSign(item)"
              >
                <span>{{ item.realName }}（{{ item.mobile }}）</span>
                <i
                  v-if="activeSignId == item.userId"
                  class="el-icon-circle-check"
                  color="white"
                ></i>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
      <span slot="footer" class="dialog-footer" v-if="signList.length">
        <el-button @click="close">取 消</el-button>
        <el-button type="primary" @click="signTask">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { base3xHarf } from "@/api/base"; // 导入接口域名列表
export default {
  props: {
    // 弹框是否打开
    contractSignVisible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      contractSignDialog: false,
      base3xHarf: base3xHarf(),
      activeSignId: "",
      signList: [],
      fddInformation: {
        company: false,
        member: false,
      },
    };
  },
  watch: {
    contractSignVisible: {
      handler(newV) {
        console.log("打开弹层");
        this.contractSignDialog = newV;
      },
    },
  },
  methods: {
    openDialog() {
      this.getSign();
    },
    // 取消
    close() {
      this.fddInformation = {
        company: false,
        member: false,
      };
      this.signList = [];
      this.activeSignId = "";
      this.contractSignDialog = false;

      this.$emit("close");
    },
    // 选择签章人
    setActiveSign(item) {
      console.log(item);
      this.activeSignId = item.userId;
    },

    // 签章管理，去续费
    go3xPage() {
      let time = Math.floor(Date.now() / 1000) + 3600;
      this.$api.user
        .getShortUrl({
          rawUrl: this.base3xHarf + "/workspace/my-contract-index",
          userId: JSON.parse(localStorage.getItem("companyInfo")).userId,
          orgId: JSON.parse(localStorage.getItem("companyInfo")).orgId,
          name: JSON.parse(localStorage.getItem("companyInfo")).loginname,
          tenantId: 0,
          expiredAt: time,
        })
        .then((res) => {
          if (res.status == "200") {
            this.noAttest = false;
            this.companyAttest = false;
            window.open(res.data, "block");
          } else {
            this.$message.error(res.msg);
          }
        });
    },

    // 签署
    getSign() {
      console.log(111);
      this.$api.user.getFddQualification().then((res) => {
        if (res.code == "200") {
          this.fddInformation = {
            company: res.company,
            member: res.member,
          };
          if (res.company && res.member) {
            this.$api.user.getFddStamp().then((res) => {
              if (res.code == "200") {
                this.activeSignId =
                  res.data && res.data.length ? res.data[0].userId : "";
                this.signList = res.data && res.data.length ? res.data : [];
              }
            });
          }
        } else {
          this.$message.error(res.msg);
        }
      });
    },

    signTask() {
      this.$api.user
        .signTask({
          taskCode: this.$route.query.id,
          userId: this.activeSignId,
        })
        .then((res) => {
          if (res.code == "200") {
            this.contractSignDialog = false;
            this.$emit("close");
            window.open(res.url, "block");
          } else {
            this.$message.error(res.msg);
          }
        });
    },
  },
};
</script>
<style scoped>
::v-deep .dialogs-box .el-dialog__body {
  border-top: 2px solid #f2f2f2;
}
el-dialog {
  width: 80% !important;
}

.title {
  margin-bottom: 10px;
}
.sign-d {
  padding: 0 10px;
  height: 30px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  border: 1px solid transparent;
}

.active-d {
  color: #fff;
  background-color: #409eff;
  border: 1px solid #999;
}
</style>
